export default Object.freeze({
    AMENDEDLIST: 'AMENDEDLIST',
    AMEND: 'AMEND',
})